module.exports = __webpack_public_path__ + "static/media/elia.b0013d51.png";